export const CLOSE = 'MODALS/CLOSE';

export const close = modal => ({
  type: CLOSE,
  payload: {
    modal,
  },
});
